<main class="auth-page compact">
  <section class="auth-card">
    <a class="brand" [routerLink]="loginRoute">
      <img class="brand-logo" src="/brand/logo-horizontal.png" alt="ZepBazaar" />
      <strong>{{ portal === 'admin' ? 'Platform Security' : 'Business Portal' }}</strong>
    </a>

    <div class="heading">
      <p>Secure reset</p>
      <h1>Create a new password</h1>
      <span>Enter the OTP sent to your registered email and choose a secure password.</span>
    </div>

    <form (ngSubmit)="onSubmit()">
      @if (otpSent) {
        <p class="otp-notice"><span class="material-symbols-outlined">mark_email_read</span><span><strong>OTP sent</strong><small>Check {{ email }} and enter the 6-digit code below.</small></span></p>
      }
      <label>
        <span>Email address</span>
        <input type="email" name="email" [(ngModel)]="email" autocomplete="email" placeholder="owner@business.in" required />
      </label>

      <label>
        <span>6-digit OTP</span>
        <input class="otp-input" name="otp" [(ngModel)]="otp" (input)="otpInputChanged()" inputmode="numeric" autocomplete="one-time-code" maxlength="6" placeholder="• • • • • •" required />
      </label>

      <label>
        <span>New password</span>
        <div class="password-field"><input [type]="showPassword ? 'text' : 'password'" name="password" [(ngModel)]="password" autocomplete="new-password" placeholder="Minimum 8 characters" required /><button type="button" class="visibility" (click)="showPassword = !showPassword" [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'"><span class="material-symbols-outlined">{{ showPassword ? 'visibility_off' : 'visibility' }}</span></button></div>
      </label>

      <label>
        <span>Confirm password</span>
        <div class="password-field"><input [type]="showConfirmation ? 'text' : 'password'" name="passwordConfirmation" [(ngModel)]="passwordConfirmation" autocomplete="new-password" placeholder="Enter password again" required /><button type="button" class="visibility" (click)="showConfirmation = !showConfirmation" [attr.aria-label]="showConfirmation ? 'Hide password' : 'Show password'"><span class="material-symbols-outlined">{{ showConfirmation ? 'visibility_off' : 'visibility' }}</span></button></div>
      </label>

      @if (successMessage) {
        <p class="state success">{{ successMessage }}</p>
      }

      @if (errorMessage) {
        <p class="state error">{{ errorMessage }}</p>
      }

      <button type="submit" [disabled]="isSubmitting">
        <span class="material-symbols-outlined" aria-hidden="true">lock_reset</span>
        {{ isSubmitting ? 'Updating...' : 'Update password' }}
      </button>
    </form>

    <p class="switch"><a [routerLink]="['/forgot-password']" [queryParams]="{ portal: portal, email: email }">Resend OTP</a><span>·</span><a [routerLink]="loginRoute">Back to sign in</a></p>
  </section>
</main>
